import React from "react";
import Bag1 from "./backpack-img/backpack-2.webp";
import Bag2 from "./backpack-img/backpack-3.webp";
import Bag3 from "./backpack-img/backpack-6.webp";
import Bag4 from "./backpack-img/backpack-10.webp";
import Bag5 from "./backpack-img/backpack-28.webp";
import Bag6 from "./backpack-img/backpack-31.webp";
import Bag7 from "./backpack-img/backpack-32.webp";
import Bag8 from "./backpack-img/backpack-33.webp";

const BackPack = [
  { id: 1, img: Bag1, name: "SBCollection", color: "Black", price: "₹313" },
  { id: 2, img: Bag2, name: "Amicoleben", color: "Black", price: "₹290" },
  {
    id: 3,
    img: Bag3,
    name: "FastFashion",
    color: "GreyWhite",
    price: "₹274",
  },
  { id: 4, img: Bag4, name: "HouseOfCommon", color: "Black", price: "₹495" },
  { id: 5, img: Bag5, name: "Shivra", color: "Grey", price: "₹499" },
  { id: 6, img: Bag6, name: "ARISTOCART", color: "Grey", price: "₹629" },
  { id: 7, img: Bag7, name: "ShopperKart", color: "Black", price: "₹899" },
  { id: 8, img: Bag8, name: "HouseOfCommon", color: "Grey", price: "₹499" },
];

export default BackPack;
